/* tslint:disable */
/* eslint-disable */
/**
 * Docusign API
 * Docusign is a service that allows the user to send the documents for signing
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: o365g_ordertakingteam_irssemal@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SignRequestUpdate
 */
export interface SignRequestUpdate {
    /**
     * The unique identifier (GUID) of the sign request to update
     * @type {string}
     * @memberof SignRequestUpdate
     */
    id: string;
}

/**
 * Check if a given object implements the SignRequestUpdate interface.
 */
export function instanceOfSignRequestUpdate(value: object): boolean {
    if (!('id' in value)) return false;
    return true;
}

export function SignRequestUpdateFromJSON(json: any): SignRequestUpdate {
    return SignRequestUpdateFromJSONTyped(json, false);
}

export function SignRequestUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignRequestUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function SignRequestUpdateToJSON(value?: SignRequestUpdate | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
    };
}

